import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutGrid, Plus, Settings as SettingsIcon, LogOut, Zap } from "lucide-react";

export default function AppLayout() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const nav = [
    { to: "/dashboard", label: "Dashboard", icon: LayoutGrid, testid: "nav-dashboard" },
    { to: "/migrations/new", label: "New Migration", icon: Plus, testid: "nav-new-migration" },
    { to: "/settings", label: "Settings", icon: SettingsIcon, testid: "nav-settings" },
  ];

  return (
    <div className="min-h-screen bg-zinc-50 flex">
      {/* Sidebar */}
      <aside className="w-64 border-r border-zinc-200 bg-white flex flex-col" data-testid="app-sidebar">
        <div className="px-6 py-6 border-b border-zinc-200">
          <Link to="/dashboard" className="flex items-center gap-2" data-testid="sidebar-logo">
            <div className="w-8 h-8 bg-zinc-950 rounded-md flex items-center justify-center">
              <Zap className="w-4 h-4 text-[#FF4F00]" strokeWidth={2.5} />
            </div>
            <span className="font-extrabold text-lg tracking-tight">MigrateFlow</span>
          </Link>
          <p className="mt-1 font-mono text-[10px] uppercase tracking-widest text-zinc-500">
            v1.0 · IMAP Engine
          </p>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          {nav.map((item) => {
            const active = location.pathname.startsWith(item.to);
            const Icon = item.icon;
            return (
              <Link
                key={item.to}
                to={item.to}
                data-testid={item.testid}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-semibold transition-all ${
                  active
                    ? "bg-zinc-950 text-white"
                    : "text-zinc-600 hover:bg-zinc-100 hover:text-zinc-950"
                }`}
              >
                <Icon className="w-4 h-4" strokeWidth={2} />
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="p-4 border-t border-zinc-200">
          <div className="mb-3 px-2">
            <p className="text-sm font-semibold truncate" data-testid="sidebar-user-name">{user?.name}</p>
            <p className="text-xs font-mono text-zinc-500 truncate">{user?.email}</p>
          </div>
          <button
            data-testid="logout-button"
            onClick={() => {
              logout();
              navigate("/login");
            }}
            className="w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm text-zinc-600 hover:bg-zinc-100 hover:text-zinc-950 transition-all"
          >
            <LogOut className="w-4 h-4" />
            Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
